/**
 * @file
 * Journey Map functionality
 */
'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.journeyMapBehaviour = {
    attach: function () {
      $(once('journeyMapBehaviour', '.node--type-journey-map')).each(function () {
        var $leftMenu = $('.cts__left-col .left-menu-list');
        var $horizontalMenu = $('.sjm__progress-line');

        // Set initial Tabs and menus settings.
        $('.cts__left-col .left-menu-list li:eq(0)').addClass('open');
        $('.main-content-menu-links li:eq(0)').addClass('open');
        $('.sjm__progress-line li:eq(0)').addClass('active');

        // Desktop Left menu handler.
        $leftMenu.find('li').click(function () {
          var $menuItem = $(this);
          var $ul = $menuItem.parent();
          var $id = $ul.attr('id').replace('side-menu-', '');
          var $mainMenu = $('#main-menu-' + $id);

          $('.left-menu-list').find('li').removeClass('open');
          $menuItem.addClass('open');
          $('.main-content-menu-links').children().removeClass('open');
          $mainMenu.children(':eq(' + $menuItem.index() + ')').addClass('open');
          return false;
        });

        // Mobile Left Menu Handler.
        $('.mobile-left-navigation').click(function() {
          var $index = $(this).parent().index();
          var $navigation = $(this).parent().parent();
          var $id = $navigation.attr('id').replace('main-menu-', '');
          $('#side-menu-' + $id).children(':eq(' + $index + ')').trigger('click');
          return false;
        });

        // Horizontal menu handler.
        $horizontalMenu.find('li a').click(function() {
          var $steps = $('.field--name-field-steps');
          var $li = $(this).parent();
          $horizontalMenu.find('li').removeClass('active');
          $li.addClass('active');
          $steps.find('.step-item').hide();
          var $contentWindow = $steps.find('.step-item:eq(' + $li.index() + ')');
          $contentWindow.show().find('.cts__left-col .left-menu-list:eq(0) ul li:eq(0)').addClass('open');
          $contentWindow.find('.main-content-menu-links:eq(0) li:eq(0)').addClass('open');
          return false;
        });

      });
    }
  };
})(jQuery, Drupal, once);
